import { Component, ErrorHandler, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { finalize } from 'rxjs';
import { ServiceAbonnementDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/service-abonnement-dto';
import { AuditHistoryEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/audit-history-enum';
import { ServiceAbonnementService } from 'src/app/api/services';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { NotificationType } from 'src/app/notifications/models/notification-models';
import { NotificationService } from 'src/app/notifications/services/notification.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ServiceabonnementTilvalgRelationDialogData } from '../../aftale/models';
import { HistoryViewComponent } from '../../shared/history/history-view/history-view.component';
import { IHistoryView } from '../../shared/history/history.model';
import { ServiceabonnementTilvalgRelationDialogComponent } from '../serviceabonnement/serviceabonnement-tilvalg-relation-dialog/serviceabonnement-tilvalg-relation-dialog.component';
import { ServiceabonnementEditComponent } from './serviceabonnement-edit/serviceabonnement-edit.component';

@Component({
  selector: 'app-serviceabonnement-list',
  templateUrl: './serviceabonnement-list.component.html',
  styleUrls: ['./serviceabonnement-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ServiceabonnementListComponent implements OnInit {
  serviceabonnementer: ServiceAbonnementDto[] = [];
  @ViewChild(MatTable) table: MatTable<any>;
  displayedColumns: string[] = ['description', 'kundetype', 'fakturaDescription', 'okKundeVarenr', 'opkraevningsinterval', 'actions'];

  constructor(
    private dialog: MatDialog,
    private service: ServiceAbonnementService,
    private notification: NotificationService,
    private errorHandler: ErrorHandler,
    private loader: LoaderService,
  ) {}

  ngOnInit(): void {
    this.loader.show();
    this.service
      .getAllAbonnements({
        caller: EGIS_SERVICE_CALLER,
      })
      .pipe(
        finalize(() => {
          this.loader.hide();
        }),
      )
      .subscribe(
        (result) => {
          this.serviceabonnementer = result.filter((x) => !x.isTilkaldsabonnement);
        },
        (error) => {
          this.errorHandler.handleError(error);
        },
      );
  }

  edit(row: ServiceAbonnementDto) {
    let dialogRef = this.dialog.open(ServiceabonnementEditComponent, {
      width: '600px',
      maxWidth: '95vw',
      data: { serviceAbonnement: row },
    });

    dialogRef.afterClosed().subscribe((p) => {
      if (p) {
        const reload = this.historyView && row.description != p.description;
        Object.assign(row, p);
        this.table.renderRows();
        if (reload) this.showhistory(row);
        this.historyViewComponent.render();
      }
    });
  }

  relations(row: ServiceAbonnementDto) {
    const data: ServiceabonnementTilvalgRelationDialogData = {
      serviceabonnement: row,
    };

    let dialogRef = this.dialog.open(ServiceabonnementTilvalgRelationDialogComponent, {
      data: data,
      width: '1000px',
    });

    dialogRef.afterClosed().subscribe((p) => {
      if (p) {
        this.notification.success('Tilvalg opdateret.');
      }
    });
  }

  @ViewChild(HistoryViewComponent) historyViewComponent: HistoryViewComponent;
  historyView: IHistoryView;

  showhistory(row: ServiceAbonnementDto) {
    this.historyView = { entityId: row.id, historyType: AuditHistoryEnum.Serviceabonnement, title: row.description };
  }
}
